
angular.module('bmsApp.settings').controller('LeavingPromptQuestionModalFormCtrl', [
	'$scope',
	'$q',
	'$timeout',
	'$filter',
	'$modalInstance',
	'$ngBootbox',
	'LeavingPromptQuestionSvc',
	'LeavingPromptQuestionTypeSvc',
	'license',
	'question', function (
		$scope,
		$q,
		$timeout,
		$filter,
		$modalInstance,
		$ngBootbox,
		LeavingPromptQuestionSvc,
		LeavingPromptQuestionTypeSvc,
		license,
		question) {

		$scope.loading = true;
		$scope.processing = false;
		$scope.options = {};

		$scope.question = angular.extend($scope.question = {
			license: license
		}, question);

		var promises = {
			leavingPromptQuestionTypeOptions: LeavingPromptQuestionTypeSvc.options(),
		};

		$q.all(promises).then(function (responses) {
			$scope.options.questionTypes = responses.leavingPromptQuestionTypeOptions.data.options;
			$scope.loading = false;
		});


		$scope.formvalidatorconfig = {
			submitHandler: function () {
				$scope.submit($scope.question);
			},
			errorPlacement: function (error) {
				error.appendTo('#leaving-prompt-question-errors');
			},
			errorContainer: '#leaving-prompt-question-errors'
		};

		$scope.submit = function (question) {
			$scope.processing = true;
			var modalResult = {};
			var savePromise = LeavingPromptQuestionSvc.save(question);
			savePromise
				.then(function (response) {
					modalResult.success = response.data.success;
					modalResult.action = question.id ? 'update' : 'create';
					modalResult.question = question;
					$modalInstance.close(modalResult);
				}, function (error) {
					modalResult.error = error;
					$modalInstance.close(modalResult);
				})
				.finally(function() {
					$scope.processing = false;
				});
		};

		$scope.cancel = function () {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					$modalInstance.dismiss('cancel');
				});
		};

	}]);
